<template>
  <div>
    <label for="firstName">First Name</label>
    <input type="text" v-model="firstName">
    <label for="lastName">Last Name</label>
    <input type="text" v-model="lastName">
    <label for="callsign">Callsign</label>
    <input id="callsign" v-model="callsign">
    <p>{{ pilotFormatted }}</p>
    <button @click="savePilotSettings" :disabled="!firstName || !lastName || !callsign">Save</button>
    <hr>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'pilot-settings',
  data() {
    return {
      firstName: '',
      lastName: '',
      callsign: '',
    }
  },
  computed: {
    pilotFormatted() {
      return `${this.firstName} ${this.callsign ? '[' + this.callsign.toUpperCase() + ']' : ''} ${this.lastName}`
    },
    ...mapState({
      playerDetails: state => state.playerDetails,
    }),
  },
  methods: {
    savePilotSettings() {
      this.setPilotDetails({
        firstName: this.firstName,
        lastName: this.lastName,
        callsign: this.callsign,
      })
      this.saveState();
      if (this.$route.name === 'setup') {
        this.$emit('pilotEntered');
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: 'smooth',
          });
        }, 50);
      }
    },
    ...mapMutations([
      'setPilotDetails',
      'setCarapaceDetails',
      'saveState',
    ]),
  },
  mounted() {
    this.firstName = this.playerDetails.pilot.firstName;
    this.lastName = this.playerDetails.pilot.lastName;
    this.callsign = this.playerDetails.pilot.callsign;
  },
}
</script>

<style scoped>

#callsign {
  text-transform: uppercase;
}
</style>
